import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const ApprovedKycApplication = () => {
  return <ObsIframe path="/approvedKYC" />;
};

export default React.memo(ApprovedKycApplication);
